import { Platform } from '@angular/cdk/platform';
import { inject } from '@angular/core';
import { LuigiCoreService } from '@openmfp/portal-ui-lib';

export function browserCheckInitializer(): void {
  const luigiCoreService = inject(LuigiCoreService);
  const platform = inject(Platform);

  // will be triggered only for browsers that are not based on Chrome or Edge.
  if (!platform.BLINK) {
    // need to wait a bit to let Luigi load completely
    const luigiCoreServiceReadyInterval = setInterval(() => {
      if (
        'showAlert' in luigiCoreService &&
        // @ts-expect-error for optional chaining
        typeof globalThis.Luigi?.showAlert === 'function'
      ) {
        luigiCoreService.showAlert({
          text: 'Your browser is not officially supported. Please use Chrome or Edge for the best experience.',
          type: 'warning',
        });
        clearInterval(luigiCoreServiceReadyInterval);
      }
    }, 1000);
  } else if (isLatestChrome()) {
    if (
      navigator.permissions &&
      typeof navigator.permissions.query === 'function'
    ) {
      const lnaPermissionName =
        'local-network-access' as unknown as PermissionName;

      navigator.permissions
        .query({ name: lnaPermissionName })
        .then((result) => {
          if (result.state !== 'granted') {
            showLnaWarning();
          }
        });
    }
  }

  function showLnaWarning(): void {
    const luigiCoreServiceReadyInterval2 = setInterval(() => {
      if (
        'showAlert' in luigiCoreService &&
        // @ts-expect-error for optional chaining
        typeof globalThis.Luigi?.showAlert === 'function'
      ) {
        luigiCoreService.showAlert({
          text: `Action required: Starting with Chrome version 142, you must grant “Local network access” for
          the application to work properly. SAP internal resources are treated as local network by
          Chrome—when prompted, please click Allow.

          Learn more: https://developer.chrome.com/blog/local-network-access`,
          type: 'warning',
        });
        clearInterval(luigiCoreServiceReadyInterval2);
      }
    }, 1000);
  }

  function getChromeMajorVersion(): number {
    const match = navigator.userAgent.match(/Chrome\/(\d+)/);
    return match ? parseInt(match[1], 10) : 0;
  }

  function isLatestChrome(): boolean {
    const ua = navigator.userAgent;
    const isChrome =
      ua.includes('Chrome') && !ua.includes('Edg') && !ua.includes('OPR');
    if (!isChrome) {
      return false;
    }
    return getChromeMajorVersion() > 141;
  }
}
